var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.0002 25.6667C20.4435 25.6667 25.6668 20.4433 25.6668 14C25.6668 7.55669 20.4435 2.33334 14.0002 2.33334C7.55684 2.33334 2.3335 7.55669 2.3335 14C2.3335 20.4433 7.55684 25.6667 14.0002 25.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3432 18.1767C12.1099 18.1767 11.8882 18.0833 11.7249 17.92L8.42318 14.6183C8.08485 14.28 8.08485 13.72 8.42318 13.3817C8.76152 13.0433 9.32152 13.0433 9.65985 13.3817L12.3432 16.065L18.3399 10.0683C18.6782 9.73001 19.2382 9.73001 19.5765 10.0683C19.9149 10.4067 19.9149 10.9667 19.5765 11.305L12.9615 17.92C12.7982 18.0833 12.5765 18.1767 12.3432 18.1767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGrey);
export default __webpack_public_path__ + "static/media/checkmark-grey.66c06b4c57713d4d80372601205cc7cc.svg";
export { ForwardRef as ReactComponent };